module.exports = __webpack_public_path__ + "img/logo.14a65605.png";